<template>
    <div id="notification-index">
        <div class="panel">
            <div class="panel-head">
                <h2>Notifications</h2>
            </div>

            <div class="panel-content">

                <label class="toggle-dismissed"><input v-model="showDismissed" type="checkbox"> show dismissed notifications</label>

                <div class="group">
                    <p class="name">Today ({{ notificationGroups.today.length }})</p>
                    <ul v-if="notificationGroups.today.length > 0" class="notifications">
                        <li v-for="notification in notificationGroups.today" :class="{ dismissed: (notification.read_at !== null)}" class="notification">
                            <p class="created">{{ notification.created_at | moment('MMM D, YYYY') }}</p>
                            <p class="title">{{ notification.data.title }}</p>
                            <p class="message">{{ notification.data.message }}</p>
                            <router-link :to="{ path: notification.data.link }" class="action">{{ notification.data.action }}</router-link>
                            <span v-if="notification.read_at !== null" class="dismiss"></span>
                            <a v-else @click.prevent.stop="dismissNotification({ id: notification.id })" href="#" class="dismiss">Dismiss</a>
                        </li>
                    </ul>
                </div>

                <div class="group">
                    <p class="name">This Week ({{ notificationGroups.week.length }})</p>
                    <ul class="notifications">
                        <li v-for="notification in notificationGroups.week" :class="{ dismissed: (notification.read_at !== null)}" class="notification">
                            <p class="created">{{ notification.created_at | moment('MMM D, YYYY') }}</p>
                            <p class="title">{{ notification.data.title }}</p>
                            <p class="message">{{ notification.data.message }}</p>
                            <router-link :to="{ path: notification.data.link }" class="action">{{ notification.data.action }}</router-link>
                            <span v-if="notification.read_at !== null" class="dismiss"></span>
                            <a v-else @click.prevent.stop="dismissNotification({ id: notification.id })" href="#" class="dismiss">Dismiss</a>
                        </li>
                    </ul>
                </div>

                <div class="group">
                    <p class="name">This Month ({{ notificationGroups.month.length }})</p>
                    <ul class="notifications">
                        <li v-for="notification in notificationGroups.month" :class="{ dismissed: (notification.read_at !== null)}" class="notification">
                            <p class="created">{{ notification.created_at | moment('MMM D, YYYY') }}</p>
                            <p class="title">{{ notification.data.title }}</p>
                            <p class="message">{{ notification.data.message }}</p>
                            <router-link :to="{ path: notification.data.link }" class="action">{{ notification.data.action }}</router-link>
                            <span v-if="notification.read_at !== null" class="dismiss"></span>
                            <a v-else @click.prevent.stop="dismissNotification({ id: notification.id })" href="#" class="dismiss">Dismiss</a>
                        </li>
                    </ul>
                </div>

                <div class="group">
                    <p class="name">This Year ({{ notificationGroups.year.length }})</p>
                    <ul class="notifications">
                        <li v-for="notification in notificationGroups.year" :class="{ dismissed: (notification.read_at !== null)}" class="notification">
                            <p class="created">{{ notification.created_at | moment('MMM D, YYYY') }}</p>
                            <p class="title">{{ notification.data.title }}</p>
                            <p class="message">{{ notification.data.message }}</p>
                            <router-link :to="{ path: notification.data.link }" class="action">{{ notification.data.action }}</router-link>
                            <span v-if="notification.read_at !== null" class="dismiss"></span>
                            <a v-else @click.prevent.stop="dismissNotification({ id: notification.id })" href="#" class="dismiss">Dismiss</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'NotificationIndex',
    data() {
        return {
            showDismissed: false
        }
    },
    created() {
        this.retrieveNotifications()
    },
    computed: {
        ...mapGetters([
            'notifications'
        ]),
        notificationGroups() {
            let groups = {
                today: [],
                week: [],
                month: [],
                year: [],
                older: []
            }

            let today = moment().startOf('day')
            let week = moment().startOf('week') // Sunday ('isoWeek' for Monday)
            let month = moment().startOf('month')
            let year = moment().startOf('year')
            this.notifications.data.forEach(item => {
                let created = moment(item.created_at)

                if(!this.showDismissed && item.read_at !== null) {
                    return false
                }

                if(created > today ) {
                    groups.today.push(item)
                } else if( created > week ) {
                    groups.week.push(item)
                } else if ( created > month ) {
                    groups.month.push(item)
                } else if ( created > year ) {
                    groups.year.push(item)
                } else {
                    groups.older.push(item)
                }
            })

            return groups
        }
    },
    methods: {
        ...mapActions([
            'retrieveNotifications',
            'dismissNotification'
        ])
    }
}
</script>

<style lang="scss">
#notification-index {

    .toggle-dismissed {
        font-size: 12px;
        float: right;
    }

    .group {
        .name {
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            color: $orange;
            border-bottom: 1px solid $light-gray;
            margin-top: 15px;
            padding: 5px 0;
        }
    }

    .notifications {
        display: table;
        width: 100%;

    }

    .notification {
        display: table-row;
        padding: 10px 0;

        &.dismissed {
            background: lighten($light-gray, 3%);
        }

        .created, .title, .message, .action, .dismiss {
            display: table-cell;
            padding: 10px 15px;
            border-bottom: 1px solid $light-gray;
        }

        .created {
            font-size: 12px;
        }

        .title {
            font-weight: 700;
        }

        .action, .dismiss {
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            color: $medium-gray;

            &:hover {
                color: $blue;
            }
        }

    }
}
</style>
